// Recovered compiled webpack factory 7755. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { qd: () => l, wg: () => c, y7: () => u });
  var n = r(51217),
    a = r(43275),
    o = r(96812),
    i = r(38599);
  let s = {};
  function l(e) {
    let t = s[e];
    if (t) return t;
    let r = i.j[e];
    if ((0, n.a3)(r)) return (s[e] = r.bind(i.j));
    let l = i.j.document;
    if (l && "function" == typeof l.createElement)
      try {
        let t = l.createElement("iframe");
        ((t.hidden = !0), l.head.appendChild(t));
        let n = t.contentWindow;
        (n?.[e] && (r = n[e]), l.head.removeChild(t));
      } catch (t) {
        o.T &&
          a.Yz.warn(`Could not create sandbox iframe for ${e} check, bailing to window.${e}: `, t);
      }
    return r ? (s[e] = r.bind(i.j)) : r;
  }
  function u(e) {
    s[e] = void 0;
  }
  function c(...e) {
    return l("setTimeout")(...e);
  }
}
